import { render, staticRenderFns } from "./BottomSheetFetchNotifications.vue?vue&type=template&id=695ee3dd&scoped=true&"
import script from "./BottomSheetFetchNotifications.vue?vue&type=script&lang=js&"
export * from "./BottomSheetFetchNotifications.vue?vue&type=script&lang=js&"
import style0 from "./BottomSheetFetchNotifications.vue?vue&type=style&index=0&id=695ee3dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695ee3dd",
  null
  
)

component.options.__file = "BottomSheetFetchNotifications.vue"
export default component.exports